<template>
    <div class="business-menu-container">
      <div class="row">
        <div class="d-flex">
          <img
            src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/S%C3%A9minaire/organisation+sur-mesure.webp"
            alt="Business"
            class="img-business pr-2"
          />
          <div class="d-flex flex-column justify-content-between align-items-start w-100 overflow-hidden">
            <span class="merriweather-bold-p16 pl-4">Hortense for Business</span>
  
            <div class="business-section px-4 py-3">
              <div
                v-for="item in businessItems"
                :key="item[0]"
                @click="goTo(item[1])"
              >
                <div class="raleway-medi-p15 text-nowrap text-left item-link">
                  {{ item[0] }}
                </div>
              </div>
            </div>
  
            <div class="align-items-center all-business d-flex justify-content-center pt-2 pl-4 w-100 text-nowrap">
              <a href="/pages/contact/" class="hortense-btn-primary raleway-bold-p" target="_blank">NOUS CONTACTER</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'NavbarBusiness',
    data() {
      return {
        businessItems: [
          ["Séminaires d'entreprise", "/seminaire-eco-responsable"],
          ["Coffrets cadeaux entreprise", "/coffrets-cadeaux-entreprise"],
          ["Coffrets cadeaux CSE", "/coffrets-cadeaux-cse"],
          ["Hortense for Travel Advisor", "/dmc-luxe-france"]
        ]
      };
    },
    methods: {
      goTo(link) {
        window.open(link, '_blank');
      }
    }
  };
  </script>
  
  <style scoped>
  .business-menu-container {
    top: 160px;
    left: 21px;
    gap: 32px;
    padding: 24px 32px;
    text-transform: capitalize !important;
  
    .img-business {
      width: 200px;
      height: 342px;
      object-fit: cover;
    }
  
    .business-section {
      display: grid;
      grid-template-columns: repeat(1, 1fr);
      gap: 30px;
  
      .item-link {
        cursor: pointer;
        &:hover {
          text-decoration: underline;
        }
      }
    }
  
    .raleway-bold-16 {
      font-family: 'Raleway';
      font-weight: 700;
      font-size: 16px;
    }
  
    @media screen and (max-width: 1400px) {
      .hortense-btn-primary {
        padding: 16px 20px;
      }
    }
  }
  </style>
  